import { useEffect, useState, useMemo } from "react";
import { Avatar } from "@mui/material";
import { FlexGrid, Skeleton } from "@albo-ui/core";
import { customStyles2 } from "../../../../util/TableStyles";
import { noDataComponent } from "../../../../util/DataObject";
import { Visibility } from "@mui/icons-material";
import DataTable from "react-data-table-component";
import { rewardsTxType } from "../../../../util/DataObject";

import moment from "moment";
moment.locale("es");

export const useCouponDetail = (row) => {
    const [data, setData] = useState({});

    useEffect(() => {
        setData({});
        setData(row.data);
    }, [row]);

    const calculateColumns = useMemo(() => {
        const columns = []
        columns.push(
            { selector: (row, index) => <Avatar alt={"image-"+index} src={row.active ? row.icon_enabled_url : row.icon_disabled_url} sx={{width: "2.2rem", height: "2.2rem"}}/>, name: "", width: "5%", wrap: true, sortable: false },
            { selector: (row) => row.title, name: "Titulo", width: "20%", wrap: true, sortable: false },
            { selector: (row) => row.description_coupon, name: "Descripción", width: "25%", wrap: true, sortable: false },
            { selector: (row) => row.value_coupon || "N/A", name: "Valor", wrap: true, sortable: false },
            { selector: (row) => rewardsTxType.filter(item => item.key === row.type)[0]["label"], name: "Tipo", wrap: true, sortable: false },
            { selector: (row) => row.active ? "Activo" : "Inactivo", name: "Estado", wrap: true, sortable: false },
            { cell: (row) => {
                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                    return <a href="#" onClick={() => window.open(row.url_detail, "_blank")} title="Abrir detalle"><Visibility /></a>
                }, name: "Detalle",  wrap: true, sortable: false
            }
        )
        
        return columns;
    }, []);

    return (
        <FlexGrid container spacing={2} style={{ marginBottom: "20px" }}>
            {!data ? (
                <Skeleton width="100%" height="100px" />
            ) : (
                <DataTable
                    columns={calculateColumns}
                    data={data["coupons"]}
                    customStyles={customStyles2}
                    noDataComponent={noDataComponent}
                />
            )}
        </FlexGrid>
    );
};
